var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-nav'),(_vm.$route.name==='index')?_c('HomePage',{staticStyle:{"width":"1200px","margin":"auto"}}):_c('keep-alive',{attrs:{"include":"goodslist"}},[_c('router-view',{staticStyle:{"min-height":"calc(100vh - 392px)"}})],1),_c('footer-nav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }